import { sport, oddsTypeUOF } from 'constants/enum';

const meridian = {
  [sport.esoccer]: {
    'pre': [

    ],
    'live': [
      oddsTypeUOF[sport.esoccer].live.three_way_live,
      oddsTypeUOF[sport.esoccer].live.total,
      oddsTypeUOF[sport.esoccer].live.total_first_half,
      oddsTypeUOF[sport.esoccer].live.nextgoal,
      oddsTypeUOF[sport.esoccer].live.halftime_1x2,
      oddsTypeUOF[sport.esoccer].live.goals_hometeam,
      oddsTypeUOF[sport.esoccer].live.goals_awayteam,
      oddsTypeUOF[sport.esoccer].live.restofthematch,
      oddsTypeUOF[sport.esoccer].live.draw_no_bet,
      oddsTypeUOF[sport.esoccer].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.esoccer].live.double_chance,
      oddsTypeUOF[sport.esoccer].live.handicap,
      oddsTypeUOF[sport.esoccer].live.asian_handicap,
      oddsTypeUOF[sport.esoccer].live.asian_handicap_first_half,
    ],
  },
};


export default meridian;
